import localStorage from "../../../utils/local-storage";

export type FeatureInstruction = {
    title: string;
    image: string;
    description: string;
    id: number;
}

export const featuresInstructions: FeatureInstruction[] = [
    {
        id: 1,
        title: 'Añadir canciones a la cola',
        image: 'https://torresowo.myftp.org/cap17drive/v2/files/5c814d9ce7548f5545e3095dc438948f',
        description: 'Desliza una canción a la derecha para añadirla a la cola.'
    },
    {
        id: 2,
        title: 'Opciones del reproductor',
        image: 'https://torresowo.myftp.org/cap17drive/v2/files/48cbd4e1072a96d8dd9434c5994491c9',
        description: 'Desde opciones puedes vaciar la cola y eliminar el historial de reproducción.'
    },
]

export const getLastFeatureId = () => {
    return localStorage.getItem('spitip17an_lastFeatureId') || 0;
}

export const areNewFeaturesAvailable = () => {
    const lastId = getLastFeatureId();
    const lastInstructionsId = featuresInstructions[featuresInstructions.length - 1].id;
    return lastId < lastInstructionsId;
};

export const setLastFeatureId = (id: number) => {
    localStorage.setItem('spitip17an_lastFeatureId', id);
};

export const getNewFeatures = () => {
    const lastId = getLastFeatureId();

    return featuresInstructions.filter(instruction => instruction.id > lastId);
};